<template>
  <div class="auth-get-started">
    <div>
      <div class="heading-4 black--text">
        Get started. <br />
        Yield smarter with an Unagii Account.
      </div>
      <div class="mt-10">
        <div class="d-flex align-center">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Instant access to consolidated portfolio across products anywhere
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Stay updated with latest news and exclusive notifications
          </div>
        </div>
        <div class="d-flex align-center mt-3">
          <v-icon small color="primary">fa-check-circle</v-icon>
          <div class="text-4 darkgray--text ml-3">
            Potential to earn campaign bonuses
          </div>
        </div>
      </div>
      <ValidationObserver ref="observer">
        <form @submit.prevent="checkEmailExisted">
          <div class="mt-8 d-flex flex-column flex-sm-row align-sm-start">
            <div class="flex-1">
              <ValidationProvider
                v-slot="{ errors }"
                name="Email"
                rules="required|email"
                mode="passive"
              >
                <v-text-field
                  autofocus
                  id="email"
                  placeholder="Email address"
                  outlined
                  single-line
                  class="c-input"
                  v-model="emailInput"
                  type="email"
                  required
                  hide-details="auto"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </div>
            <input type="submit" class="d-none" />
            <div>
              <c-btn
                class="ml-sm-5 mt-3 mt-sm-0"
                :loading="checking"
                @click="checkEmailExisted"
                >Continue</c-btn
              >
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div class="mt-5 text-6 gray--text text-center ml-3 mr-3">
        or
      </div>
      <div class="mt-5">
        <social-auth />
      </div>
      <div class="mt-5 text-6 darkgray--text text-center">
        By continuing, you agree to Unagii’s
        <a
          href="https://www.unagii.com/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Terms & Conditions</a
        >
        and
        <a
          href="https://www.unagii.com/legal/privacy"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >Privacy Policy</a
        >.
      </div>
    </div>
    <div>
      <v-divider class="mt-10 mb-10"></v-divider>
      <continue-anonymously @showConnectWallet="$emit('showConnectWallet')" />
    </div>
    <div class="mt-10">
      <protect-statement />
    </div>
  </div>
</template>

<script>
import SocialAuth from "./SocialAuth";
import ContinueAnonymously from "./ContinueAnonymously";
import ProtectStatement from "./ProtectStatement";
import { required, email } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("passive");
extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});
extend("email", {
  ...email,
  message: "Enter valid email address.",
});

export default {
  components: {
    SocialAuth,
    ContinueAnonymously,
    ProtectStatement,
    ValidationObserver,
    ValidationProvider,
  },
  props: ["email"],
  data: () => ({
    emailInput: null,
    checking: false,
  }),
  methods: {
    async checkEmailExisted() {
      const isFormValid = await this.$refs.observer.validate();
      if (!isFormValid) return;
      this.$emit("setEmail", this.emailInput);
      this.checking = true;
      const { emailExisted } = await this.$store.dispatch(
        "auth/checkEmailExisted",
        this.emailInput
      );
      this.$emit("setComponent", emailExisted ? "LogIn" : "SignUp");
      this.checking = false;
    },
  },
  mounted() {
    this.emailInput = this.email;
    if (this.email) {
      this.$nextTick(() => {
        this.checkEmailExisted();
      });
    }
  },
};
</script>
